import React, { useState } from 'react';
import PageLayout from '../../../shared/ui/layouts/PageLayout/PageLayout';
import { ImmotionAuftragSection } from '../../../features/work-order';
import { useCreateWorkOrder } from '../../../entities/work-order';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../shared/config/routes';

export const WorkOrderCreatePage = () => {
  const [immotionAuftragId, setImmotionAuftragId] = useState('');

  const navigate = useNavigate();
  const { mutateAsync: createWorkOrder } = useCreateWorkOrder();

  const onSubmit = async () => {
    const normalizedAuftragId = immotionAuftragId.trim();
    if (!normalizedAuftragId) return;

    await createWorkOrder({ workOrderId: normalizedAuftragId });
    navigate(routes.task.detail(normalizedAuftragId));
  };

  return (
    <PageLayout
      pageTitle={'Neuer Auftrag'}
      scrollable
      primaryAction={{
        label: 'Speichern',
        onClick: onSubmit,
      }}
    >
      <div className="flex flex-row gap-[60px] mt-6 justify-between max-h-full">
        <ImmotionAuftragSection
          immotionAuftragId={immotionAuftragId}
          onImmotionAuftragIdChange={setImmotionAuftragId}
        />
      </div>
    </PageLayout>
  );
};
